import React from 'react';

function Badge({ openLink, imageUrl, displayText }) {
    return (
        <a href={openLink} className="btn pr-2 mr-2 social-link-badge" target="_blank" rel="noreferrer">
            <img alt="" className="social-link-icon" src={imageUrl}></img>
            <p className="social-link-display-text m-0 px-2">{displayText}</p>
        </a>
    );
}

export default Badge;